<template>
  <transition name="fade">
    <div>
      <div class="row justify-content-center">
        <div class="col-lg-10 col-md-12 col-sm-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title bold d-none d-sm-block">
                PEP and DOSRI Declaration
              </h3>

              <div class="card-tools">
                <span>Preferred Language:</span>
                <select
                  class="ml-1 form-control custom-select-sm"
                  style="width: 130px"
                  v-model="language"
                >
                  <option :value="false">English</option>
                  <option :value="true">Tagalog</option>
                </select>
              </div>
            </div>
            <div class="card-body">
              <p class="bold fs-18 text-center d-block d-sm-none">
                PEP and DOSRI Declaration
              </p>

              <div v-for="(question, index) in pep" :key="index">
                <div v-if="question.show || question.trigger_point == 'Y'">
                  <p>
                    {{ question.seq + ". " }}
                    {{ language ? question.content_tagalog : question.content }}
                  </p>
                  <div class="row">
                    <div
                      class="col-md-6 col-12 pb-2"
                      v-for="(choice, i) in question.choices"
                      :key="i"
                    >
                      <div class="icheck-primary d-inline">
                        <input
                          type="radio"
                          :id="'x' + choice.answer_id"
                          :value="choice.answer_id"
                          v-model="question.selected"
                          @change="selectAnswer(choice.answer_id)"
                        />
                        <label
                          :for="'x' + choice.answer_id"
                          :class="{
                            errorRadio:
                              submitting &&
                              $v.pep.$each[index].selected.$error,
                          }"
                        >
                          <div
                            class="text-justify"
                            v-html="
                              language ? choice.vhtml_tagalog : choice.vhtml
                            "
                          ></div>
                        </label>
                      </div>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button class="btn btn-primary" @click="btnBack()">
                <i class="fas fa-arrow-left mr-1"></i>Back
              </button>
              <button class="btn btn-primary float-right" @click="btnNext()">
                Next<i class="fas fa-arrow-right ml-1"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import AlertDismissible from "@vues/alerts/AlertDismissible.vue";
export default {
  props: ["formLoan", "user"],
  components: {
    AlertDismissible,
  },
  data() {
    return {
      error: false,
      pep: [],
      language: false,
      submitting: 0,
    };
  },
  validations: {
    pep: {
      $each: {
        selected: {
          required: requiredIf(function (obj) {
            return obj.show;
          }),
        },
      },
    },
  },
  created() {
    this.getRefPepDostri();
  },

  computed() {},

  methods: {
    selectAnswer(answer) {
      let x = answer.toString();
      switch (x) {
        case "1.1":
          this.pep[4].show = true;
          this.pep[1].show = false;
          this.pep[1].selected = "";

          this.pep[2].show = false;
          this.pep[2].selected = "";
          this.pep[3].show = false;
          this.pep[3].selected = "";
          break;
        case "1.2":
          this.pep[1].show = true;
          this.pep[4].show = false;
          this.pep[4].selected = "";
          break;
        case "2.1":
          this.pep[2].show = true;
          this.pep[4].show = false;
          this.pep[4].selected = "";
          break;
        case "2.2":
          this.pep[2].show = true;
          this.pep[4].show = false;
          this.pep[4].selected = "";
          break;
        case "2.3":
          this.pep[4].show = true;
          this.pep[2].show = false;
          this.pep[2].selected = "";
          this.pep[3].show = false;
          this.pep[3].selected = "";
          break;
        case "2.4":
          this.pep[4].show = true;
          this.pep[2].show = false;
          this.pep[2].selected = "";
          this.pep[3].show = false;
          this.pep[3].selected = "";
          break;
        case "3.1":
          this.pep[3].show = true;
          break;
        case "3.2":
          this.pep[3].show = true;
          break;
        case "4.1":
          this.pep[4].show = true;
          break;
        case "4.2":
          this.pep[4].show = true;
          break;
        default:
      }
    },

    getRefPepDostri() {
      this.$emit("load", 1);
      axios
        .get("/api/v2-ref-pep-dostri2")
        .then((res) => {
          let data = res.data;
          this.pep = data.pep;
          this.$emit("load", -1);
        })
        .catch((err) => {
          this.$emit("load", -1);
        });
    },

    btnBack() {
      this.$emit('back')
    },

    btnNext() {
      const fields = this.pep
        .filter((obj) => obj.selected !== "")
        .map((obj) => ({
          id: obj.id,
          selected: obj.selected,
        }));

      const form = {
        pep: fields,
        application_id: this.formLoan.application_id,
      };

      this.submitting = 1;
      this.$v.pep.$touch();
      if (this.$v.pep.$invalid) {
        Swal.fire({
          icon: "warning",
          text: `Please provide the required information in the following fields`,
          allowOutsideClick: false,
        });
      } else {
        this.$emit("load", 1);
        axios
          .post("/api/v2-rise-post-pep-dostri2", form)
          .then((res) => {
            this.$emit("load", -1);

            this.$emit("next");
          })
          .catch((err) => {
            this.$emit("load", -1);
          });
      }
    },
  },
  computed: {},
  mounted() {},
};
</script>



<style scoped>
</style>